import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import "./Opensource.css";

class Opensource extends Component {
  render() {
    return <Redirect to="/" />;
    // (
    //   <div className="opensource-main">
    //     <Header theme={this.props.theme} />
    //     <Organizations theme={this.props.theme} />
    //     <OpensourceCharts theme={this.props.theme} />
    //     <PullRequests theme={this.props.theme} />
    //     <Issues theme={this.props.theme} />
    //     <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
    //     <TopButton theme={this.props.theme} />
    //   </div>
    // );
  }
}

export default Opensource;
